import News from "@/(front-desk)/(pages)/news/[category]/News"

export const categoryList = {
    all: "所有訊息",
    announcement: "訊息公告",
    media: "媒體報導",
    column: "放視專欄",
    lecture: "系列講座",
    activity: "活動紀錄"
}
export async function generateStaticParams() {
    return Object.keys(categoryList).map((category) => ({
        category: category,
    }))
}
export default function news({ params }) {
    return (
        <News category={params.category}/>
    )
}
